import React from "react";
import CardWrapper from "@components/StrapiComponents/CardWrapper";
import FaqComponent from "@components/StrapiComponents/FAQs";
import FeatureStats from "@components/StrapiComponents/FeatureStats";
import ImageWrapper from "@components/StrapiComponents/ImageWrapper";
import LastScrollCTA from "@components/StrapiComponents/LastScrollCTA";
import SingleFeatureWithImage from "@components/StrapiComponents/SingleFeatureWithImage";
import Steps from "@components/StrapiComponents/Steps";
import Testimonials from "@components/StrapiComponents/Testimonial";
import ThreePointHighlighter from "@components/StrapiComponents/ThreePointHighlighter";
import TileWrapper from "@components/StrapiComponents/TileWrapper";
import { TimeLine } from "@components/StrapiComponents/TimeLine";
import TimedFeatureList from "@components/StrapiComponents/TimedFeatureList";
import TreeWithThreeTiles from "@components/StrapiComponents/TreeWithThreeTiles";
import { StrapiComponentTypes } from "@models/strapi-component";
import { CardWrapperDynamicZoneModel } from "@models/strapi-components/card-wrapper";
import { FaqDynamicZoneModel } from "@models/strapi-components/faq-dynamic-zone";
import { FeatureStatsDynamicZoneModel } from "@models/strapi-components/feature-stats";
import { ImageWrapperDynamicZoneModel } from "@models/strapi-components/image-wrapper";
import { LastScrollCTADynamicZoneModel } from "@models/strapi-components/last-scroll-cta";
import { SingleFeatureWithImageDynamicModel } from "@models/strapi-components/single-feature-with-image";
import { StepsDynamicZoneModel } from "@models/strapi-components/steps";
import { TestimonialsDynamicZoneModel } from "@models/strapi-components/testimonials";
import { ThreePointsHighLighterDynamicZoneModel } from "@models/strapi-components/three-points";
import { TileWrapperDynamicZoneModel } from "@models/strapi-components/tile-wrapper";
import { TimedFeatureDynamicZoneModel } from "@models/strapi-components/timed-feature-list";
import { TimelineDynamicZoneModel } from "@models/strapi-components/timeline";
import { TreeWithThreeTilesDynamicZoneModel } from "@models/strapi-components/tree-with-three-tiles";
import { DynamicZoneComponentType } from "@models/all-dynamic-zone-components";
import { BentoGridDynamicZoneModel } from "@models/strapi-components/bento-grid";
import BentoGrid from "@components/StrapiComponents/BentoGrid";
import { QuestionAnswerDynamicZoneModel } from "@models/strapi-components/question-answer";
import QuestionAnswer from "@components/StrapiComponents/QuestionAnswer";
import {
  HpStatsDynamicZoneModel,
  HpStatsVariant,
} from "@models/strapi-components/hp-stats";
import HpStats from "@components/StrapiComponents/HpStats";
import { IFrameWrapperDynamicZoneModel } from "@models/strapi-components/iframe-wrapper";
import IFrameWrapper from "@components/StrapiComponents/IFrameWrapper";
import FeaturedPodcast from "@components/StrapiComponents/FeaturedPodcast";
import { FeaturedPodcastDynamicZoneModel } from "@models/strapi-components/feature-podcast";
import { HubSpotFormDataModel } from "@models/strapi-components/hubspot";
import { TimeDelta } from "@components/StrapiComponents/TimeDelta";
import { TimeDeltaDynamicZoneModel } from "@models/strapi-components/time-delta";

type Props = {
  hubspotForm?: HubSpotFormDataModel;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useDynamicZone = (_arg: Props) => {
  const renderTimedFeatures = (componentData: TimedFeatureDynamicZoneModel) => (
    <div>
      <TimedFeatureList componentData={componentData} />
    </div>
  );

  const renderSingleFeatureWithImage = (
    componentData: SingleFeatureWithImageDynamicModel
  ) => (
    <div>
      <SingleFeatureWithImage componentData={componentData} />
    </div>
  );

  const renderTileWrapper = (
    componentData: TileWrapperDynamicZoneModel,
    offsetClass: string
  ) => (
    <div>
      <TileWrapper componentData={componentData} offsetClass={offsetClass} />
    </div>
  );

  const renderImageWrapper = (
    componentData: ImageWrapperDynamicZoneModel,
    offsetClass: string
  ) => (
    <div>
      <ImageWrapper componentData={componentData} offsetClass={offsetClass} />
    </div>
  );
  const renderTesimonials = (componentData: TestimonialsDynamicZoneModel) => (
    <div>
      <Testimonials componentData={componentData} />
    </div>
  );

  const renderLastScrollCTA = (
    componentData: LastScrollCTADynamicZoneModel
  ) => (
    <div>
      <LastScrollCTA componentData={componentData} />
    </div>
  );

  const renderFeatureStats = (componentData: FeatureStatsDynamicZoneModel) => (
    <div>
      <FeatureStats componentData={componentData} />
    </div>
  );

  const renderTreeWithThreeTiles = (
    componentData: TreeWithThreeTilesDynamicZoneModel
  ) => (
    <div>
      <TreeWithThreeTiles componentData={componentData} />
    </div>
  );

  const renderFaqs = (componentData: FaqDynamicZoneModel) => (
    <div>
      <FaqComponent componentData={componentData} />
    </div>
  );

  const renderSteps = (componentData: StepsDynamicZoneModel) => (
    <div>
      <Steps componentData={componentData} />
    </div>
  );
  const renderCardWrapper = (componentData: CardWrapperDynamicZoneModel) => (
    <div>
      <CardWrapper componentData={componentData} />
    </div>
  );
  const renderThreePointHighlighter = (
    componentData: ThreePointsHighLighterDynamicZoneModel
  ) => (
    <div>
      <ThreePointHighlighter componentData={componentData} />
    </div>
  );
  const renderTimelineWrapper = (componentData: TimelineDynamicZoneModel) => (
    <div>
      <TimeLine componentData={componentData} />
    </div>
  );

  const renderBentoGrid = (componentData: BentoGridDynamicZoneModel) => (
    <div>
      <BentoGrid componentData={componentData} />
    </div>
  );

  const renderQuestionAnswer = (
    componentData: QuestionAnswerDynamicZoneModel
  ) => (
    <div>
      <QuestionAnswer componentData={componentData} />
    </div>
  );

  const renderHpStats = (componentData: HpStatsDynamicZoneModel) => (
    <div>
      <HpStats
        componentData={{ ...componentData, variant: HpStatsVariant.OTHER }}
      />
    </div>
  );

  const renderIFrames = (componentData: IFrameWrapperDynamicZoneModel) => (
    <IFrameWrapper componentData={componentData} />
  );

  const renderFeaturedPodcast = (
    componentData: FeaturedPodcastDynamicZoneModel
  ) => <FeaturedPodcast componentData={componentData} />;

  // const renderFormWithGifOrVideo = (
  //   componentData: FormWithGifOrVideoDynamicZoneModel
  // ) => (

  //   <FormWithGifOrVideo
  //     componentData={componentData}
  //     hubspotForm={hubspotForm}
  //   />
  // );

  const renderTimeDelta = (componentData: TimeDeltaDynamicZoneModel) => (
    <TimeDelta componentData={componentData} />
  );

  const renderDynamicZone = (
    dynamicZone: DynamicZoneComponentType,
    offsetClass: string = ""
  ) => {
    const { strapi_component: strapiComponent } = dynamicZone;
    let renderComponent = <></>;
    switch (strapiComponent) {
      case StrapiComponentTypes.TimedFeatureList:
        //
        renderComponent = renderTimedFeatures(
          dynamicZone as TimedFeatureDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.SingleFeatureWithImage:
        //
        renderComponent = renderSingleFeatureWithImage(
          dynamicZone as SingleFeatureWithImageDynamicModel
        );
        break;
      case StrapiComponentTypes.TileWrapper:
        //
        renderComponent = renderTileWrapper(
          dynamicZone as TileWrapperDynamicZoneModel,
          offsetClass
        );
        break;
      case StrapiComponentTypes.ImageWrapper:
        //
        renderComponent = renderImageWrapper(
          dynamicZone as ImageWrapperDynamicZoneModel,
          offsetClass
        );
        break;
      case StrapiComponentTypes.TestimonialSlider:
        //
        renderComponent = renderTesimonials(
          dynamicZone as TestimonialsDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.LastScrollCTA:
        //
        renderComponent = renderLastScrollCTA(
          dynamicZone as LastScrollCTADynamicZoneModel
        );
        break;

      case StrapiComponentTypes.FeatureStats:
        //
        renderComponent = renderFeatureStats(
          dynamicZone as FeatureStatsDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.TreeWithThreeTiles:
        //
        renderComponent = renderTreeWithThreeTiles(
          dynamicZone as TreeWithThreeTilesDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.FAQ:
        //
        renderComponent = renderFaqs(dynamicZone as FaqDynamicZoneModel);
        break;
      case StrapiComponentTypes.Steps:
        //
        renderComponent = renderSteps(dynamicZone as StepsDynamicZoneModel);
        break;
      case StrapiComponentTypes.CardWrapper:
        //
        renderComponent = renderCardWrapper(
          dynamicZone as CardWrapperDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.ThreePointHighLighter:
        //
        renderComponent = renderThreePointHighlighter(
          dynamicZone as ThreePointsHighLighterDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.Timeline:
        //
        renderComponent = renderTimelineWrapper(
          dynamicZone as TimelineDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.BentoGrid:
        //
        renderComponent = renderBentoGrid(
          dynamicZone as BentoGridDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.QuestionAnswer:
        //
        renderComponent = renderQuestionAnswer(
          dynamicZone as QuestionAnswerDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.HpStats:
        renderComponent = renderHpStats(dynamicZone as HpStatsDynamicZoneModel);
        break;
      case StrapiComponentTypes.IFrameWrapper:
        renderComponent = renderIFrames(
          dynamicZone as IFrameWrapperDynamicZoneModel
        );
        break;
      case StrapiComponentTypes.FeaturedPodcast:
        renderComponent = renderFeaturedPodcast(
          dynamicZone as FeaturedPodcastDynamicZoneModel
        );
        break;
      // case StrapiComponentTypes.FormWithGifOrVideo:
      //   renderComponent = renderFormWithGifOrVideo(
      //     dynamicZone as FormWithGifOrVideoDynamicZoneModel
      //   );
      //   break;
      case StrapiComponentTypes.TimeDelta:
        renderComponent = renderTimeDelta(
          dynamicZone as TimeDeltaDynamicZoneModel
        );
        break;
      default:
        break;
    }
    return renderComponent;
  };

  return { renderDynamicZone };
};
export default useDynamicZone;
